// cell width and height for normal body cells
export const DEFAULT_CELL_WIDTH = 100;
export const CELL_HEIGHT = 30;

// values for computing header width
export const ROW_TOGGLE_ICON_WIDTH = 0;
export const CELL_PADDING = 16;

export const MIN_HEADER_CELL_WIDTH = 80;
const MAX_HEADER_CONTENT_WIDTH = 320;
export const MAX_HEADER_CELL_WIDTH = MAX_HEADER_CONTENT_WIDTH + CELL_PADDING;

// the left header has some additional padding on the left to align with the title
export const LEFT_HEADER_LEFT_SPACING = 24;

export const MAX_ROWS_TO_MEASURE = 100;

export const RESIZE_HANDLE_WIDTH = 5;

export const PIVOT_TABLE_BODY_LABEL = "pivot-table-body-grid";
